import React, { forwardRef, useId } from 'react';
import Field, { inputClass, describedBy } from './Field';

const TextArea = forwardRef(({
  label,
  hint,
  error,
  required,
  optionalLabel,
  className,
  id: idProp,
  name,
  rows = 3,
  ...rest
}, ref) => {
  const generatedId = useId();
  const id = idProp || `${name || 'textarea'}-${generatedId}`;

  return (
    <Field id={id} label={label} hint={hint} error={error} required={required} optionalLabel={optionalLabel} className={className}>
      <textarea
        ref={ref}
        id={id}
        name={name}
        rows={rows}
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={describedBy(id, { hint, error })}
        aria-required={required || undefined}
        className={inputClass(Boolean(error), 'resize-y')}
        {...rest}
      />
    </Field>
  );
});

TextArea.displayName = 'TextArea';

export default TextArea;
